import React, { useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

import CustomButton from "components/CustomButton";
import AddIcon from "@mui/icons-material/Add";
import GoalForm from "./GoalForm";

ChartJS.register(ArcElement, Tooltip, Legend);

export const data = {
  datasets: [
    {
      data: [60, 20, 20],
      backgroundColor: ["#34AA70", "#F3B535", "#ffffff"],
      borderColor: ["rgba(255, 206, 86, 1)", "rgba(255, 206, 86, 1)", "rgba(255, 206, 86, 1)"],
      borderWidth: 1,
    },
  ],
};

const options = {
  radius: "90%",
};

const GoalSetting: React.FC = () => {
  const [goalFormOpen, setGoalFormOpen] = useState<boolean>(false);

  const handleGoalFormOpen = () => {
    setGoalFormOpen(true);
  };

  const handleGoalFormClose = () => {
    setGoalFormOpen(false);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h5" sx={{ fontSize: "20px", fontWeight: 800, opacity: 0.8 }}>
            Goals
          </Typography>{" "}
          <Typography variant="h6" sx={{ fontSize: "14px", opacity: 0.7 }}>
            Goals Overview
          </Typography>
        </Box>
        <CustomButton startIcon={<AddIcon />} title="Create Goal" onClick={handleGoalFormOpen} />
        <GoalForm goalFormOpen={goalFormOpen} handleGoalFormClose={handleGoalFormClose} />
      </Box>
      <Divider />
      <Box width={250} height={250} margin="auto">
        <Doughnut data={data} options={options} />
      </Box>
    </Box>
  );
};

export default GoalSetting;
